import { FunctionalComponent } from 'preact';

import zoolifeLogo from '../ZoolifeLogo/zoolife.svg';

interface VideoEndScreenProps {
  message?: string;
}

const VideoEndScreen: FunctionalComponent<VideoEndScreenProps> = ({ message = 'Discover my story, only on zoolife' }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-secondary-green">
    <img src={zoolifeLogo} alt="zoolife" className="w-[158px] brightness-0 invert md:w-[284px]" />
    <p className="preflight preflight-p mt-4 text-center text-[16px] text-white md:text-[24px]">{message}</p>
  </div>
);

export default VideoEndScreen;
